"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var estilosModal = require("./Modal.module.scss");
var Modal = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, _d = _a.children, children = _d === void 0 ? null : _d, _e = _a.botaoFechar, botaoFechar = _e === void 0 ? false : _e, _f = _a.style, style = _f === void 0 ? {} : _f, _g = _a.corDeFundo, corDeFundo = _g === void 0 ? null : _g;
    if (!isOpen)
        return null;
    return (react_1.default.createElement("div", { className: estilosModal.modalSobreposto, onClick: onClose },
        react_1.default.createElement("div", { className: estilosModal.modalConteudo, onClick: function (e) { return e.stopPropagation(); }, style: __assign({ backgroundColor: corDeFundo !== null && corDeFundo !== void 0 ? corDeFundo : 'default' }, style) },
            botaoFechar &&
                react_1.default.createElement("div", { className: estilosModal.botaoFechar, onClick: onClose, style: { cursor: 'pointer' } },
                    react_1.default.createElement(Icone_1.Icone, { cor: Cores_1.Cores.CoresIdentidadeMU.cinzaMu, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU, nome: "close" })),
            children)));
};
exports.Modal = Modal;
